import axios from "axios";
import { messaging, requestForToken, onMessage } from "./firebase";
import { createRoot } from "react-dom/client";
import NotificationManager from "../Component/Notification/NotificationManager";
import React from "react";

let notificationContainer = null;
let notificationRoot = null;
let notifications = [];

const closeNotificationById = (id) => {
  notifications = notifications.filter((n) => n.id !== id);
  renderNotifications();
};

const renderNotifications = () => {
  if (!notificationContainer) {
    notificationContainer = document.createElement('div');
    document.body.appendChild(notificationContainer);
    notificationRoot = createRoot(notificationContainer);
  }

  notificationRoot.render(
    <NotificationManager
      notifications={notifications}
      onClose={closeNotificationById}
    />
  );
};

const showNotificationPopup = (title, body, image, deepLink) => {
  const id = Date.now() + Math.random();
  const notification = {
    id,
    title,
    body,
    image,
    deepLink: deepLink || null,
  };

  notifications.push(notification);
  renderNotifications();

  // Auto-close after 10 seconds
  setTimeout(() => {
    closeNotificationById(id);
  }, 10000);

  // Notify app to show red dot on bell icon
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("notification-received"));
  }
};

// Completely disable in-app notification popups for the admin panel.
// These functions are kept as no-ops so existing imports continue to work.
export const initializeNotifications = () => {
  return;
};

export const registerFCMToken = async () => {
  return;
};

export const requestNotificationPermission = async () => {
  return;
};
